import { Component } from 'react';
import { connect } from 'formik';
import { debounce, omit, pick, merge, get, isEmpty } from 'lodash';
import isEqual from 'react-fast-compare';

class PersistImpl extends Component {
  static defaultProps = {
    debounce: 300,
  };

  saveForm = debounce(data => {
    if (!data.isValid) return;
    const dataToSave = this.omitIgnoredFields(data);

    if (this.props.isSessionStorage) {
      window.sessionStorage.setItem(
        this.props.name,
        JSON.stringify(dataToSave)
      );
    } else {
      window.localStorage.setItem(this.props.name, JSON.stringify(dataToSave));
    }
  }, this.props.debounce);

  omitIgnoredFields = data => {
    const { ignoreFields } = this.props;
    const { values, initialValues, touched, errors } = data;
    return ignoreFields
      ? {
          ...data,
          initialValues: omit(initialValues, ignoreFields),
          values: omit(values, ignoreFields),
          touched: omit(touched, ignoreFields),
          errors: omit(errors, ignoreFields),
        }
      : data;
  };

  getPrefilledValues = () => {
    const { prefilledFields } = this.props;
    if (!prefilledFields) return;

    const { values } = this.props.formik;
    const filteredFields = prefilledFields.filter(field => get(values, field));
    if (!filteredFields.length) return;

    return filteredFields.reduce((obj, field) => {
      const value = get(values, field);
      obj[field] = value;

      return obj;
    }, {});
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.formik, this.props.formik)) {
      this.saveForm(this.props.formik);
    }
  }

  componentDidMount() {
    const maybeState = this.props.isSessionStorage
      ? window.sessionStorage.getItem(this.props.name)
      : window.localStorage.getItem(this.props.name);
    if (maybeState && maybeState !== null) {
      const prefilledValues = this.getPrefilledValues();
      const { ignoreFields } = this.props;
      const preservedFields = pick(this.props.formik.values, ignoreFields);
      const newState = JSON.parse(maybeState);

      this.props.formik.setFormikState(
        {
          ...newState,
          values: merge(preservedFields, newState.values)
        }
        , () => {
          if (isEmpty(prefilledValues)) return;

          Object.entries(prefilledValues).forEach(([key, value]) => {
            this.props.formik.setFieldValue(key, value);
          });
      });
    }
  }

  render() {
    return null;
  }
}

export const Persist = connect(PersistImpl);